import React, { useMemo } from 'react'
import clsx from 'clsx'
import styles from 'components/Modal/modal.module.scss'
import ReactModal from 'react-modal'
import PropTypes from 'prop-types'
import useWindowSize from 'gu-ui-kit/src/utils/useWindowSize'

const ModalComponent = ({ modal, SpecifiedModal, onRequestClose }) => {
  const { width: windowWidth } = useWindowSize(300)
  const {
    modalProps: {
      breakpoints,
      shouldCloseOnOverlayClick = true,
      shouldCloseOnEsc = true,
    },
  } = modal

  const matchBreakpoints = useMemo(() => {
    if (!breakpoints || windowWidth === 0) {
      return null
    }

    return Object.entries(breakpoints).reduce((acc, [k, v]) => {
      if (windowWidth >= +k) {
        acc = v
      }

      return acc
    }, {})
  }, [windowWidth])

  const variant = useMemo(() => matchBreakpoints?.variant, [matchBreakpoints])

  if (!variant) {
    return null
  }

  return (
    <ReactModal
      portalClassName={clsx(
        'ReactModalPortal',
        modal.modalProps.portalClassName ?? '',
        styles[`portal-variant-${variant}`],
      )}
      disablePortal
      isOpen={!!modal.modalType}
      onRequestClose={() => onRequestClose(modal)}
      ariaHideApp={false}
      overlayClassName={clsx(
        'modal',
        'show',
        'fade',
        modal.modalProps.overlayClassName ?? '',
      )}
      bodyOpenClassName={modal.modalProps.bodyOpenClassName ?? 'body__modal_open'}
      className={clsx(`modal-dialog modal-${modal.modalType}`, {
        ['modal-dialog-centered']: variant !== 'fullViewport',
      })}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
    >
      <SpecifiedModal
        variant={variant}
        closeModal={() => onRequestClose(modal)}
        {...modal.modalProps}
        UUID={modal.UUID}
      />
    </ReactModal>
  )
}

export default ModalComponent

ModalComponent.propTypes = {
  modal: PropTypes.object,
  SpecifiedModal: PropTypes.elementType,
  onRequestClose: PropTypes.func,
}
